var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.9873 26.5427V34.5427C58.9873 42.5427 55.7873 45.7427 47.7873 45.7427H38.1873C30.1873 45.7427 26.9873 42.5427 26.9873 34.5427V24.9427C26.9873 16.9427 30.1873 13.7427 38.1873 13.7427H46.1873",
    fill: "url(#paint0_linear_250_7196)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9875 26.5427H52.5875C47.7875 26.5427 46.1875 24.9427 46.1875 20.1427V13.7427L58.9875 26.5427Z",
    fill: "url(#paint1_linear_250_7196)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9873 31.3428H44.5873",
    stroke: "white",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9873 37.7427H41.3873",
    stroke: "white",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2959 38.3621H13.6295C12.1568 38.3621 10.9629 39.556 10.9629 41.0287V50.3621C10.9629 51.8348 12.1568 53.0287 13.6295 53.0287H32.2959C33.7686 53.0287 34.9625 51.8348 34.9625 50.3621V41.0287C34.9625 39.556 33.7686 38.3621 32.2959 38.3621Z",
    fill: "url(#paint2_linear_250_7196)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3301 38.3626V33.0292C16.3301 31.2611 17.0324 29.5654 18.2827 28.3152C19.5329 27.0649 21.2286 26.3625 22.9966 26.3625C24.7647 26.3625 26.4604 27.0649 27.7106 28.3152C28.9608 29.5654 29.6632 31.2611 29.6632 33.0292V38.3626",
    stroke: "#374B92",
    strokeWidth: 2.66664,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_250_7196",
    x1: 42.9873,
    y1: 13.7427,
    x2: 42.9873,
    y2: 45.7427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A7FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_250_7196",
    x1: 52.5875,
    y1: 13.7427,
    x2: 52.5875,
    y2: 26.5427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B689FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_250_7196",
    x1: 12.2962,
    y1: 38.3621,
    x2: 33.6295,
    y2: 56.3617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45FFE9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLock);
export default __webpack_public_path__ + "static/media/FileLock.16a30f13fbd5cc121e1e438992a6c739.svg";
export { ForwardRef as ReactComponent };